import { Loader } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import type { FC } from 'react';

import { MainLayout } from 'src/components/layouts/main-layout/MainLayout';

import { SingleTab } from './single-tab/SingleTab';

export const TabPage: FC = observer(function TabPage() {
  const isLoading = false;

  const renderContent = () => {
    if (isLoading) {
      return <Loader size="l" />;
    }

    return <SingleTab />;
  };

  return <MainLayout title="Tab">{renderContent()}</MainLayout>;
});
